var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"logo-left",attrs:{"src":require("./assets/logo.png")}}),_c('div',{staticClass:"container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }